import { range } from 'lodash-es';

export const generateShimmeringRows = (
  numOfRows: number,
  numOfListingGroups?: number
) => {
  const numOfGroups = Math.min(5, numOfListingGroups ?? 0); // display a max of 5 group shimmers
  const numOfSingles = Math.min(200 - numOfGroups, numOfRows); // display a max of 200 - group shimmers

  const result = [
    ...(numOfGroups > 0
      ? range(0, numOfGroups, 1).map(() => ({
          listing: null,
          isLtGrp: true,
        }))
      : []),
    ...range(0, numOfSingles, 1).map(() => null),
  ];

  return result;
};
